import { number } from 'prop-types';

const ticketMassivePostponePropTypes = {
  id: number.isRequired,
};

export default ticketMassivePostponePropTypes;
